const CheckEmailValidation = (inputtext) => {
    let emailExp= /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (inputtext.match(emailExp)) {
      return true;
      }else{
        return false
      }
  };
  export default CheckEmailValidation;
  